<ng-container *ngFor="let badge of data; let i = index; trackBy: trackByBgColor;">
	<div *ngIf="badge"
		class="badge"
		[style.background-color]="badge.backgroundColor"
		[style.color]="badge.foregroundColor"
		[ngClass]="badgeClasses"
		>
		<span>{{ badge.badgeText || badge.badgeType}}</span>
	</div>
</ng-container>